
const servers = {
  langDetect: {
    id: "langDetect",
    name: "Language detect",
    description: "It's an Auto Language Detect",
    url: "https://i86asm93gi.execute-api.ap-south-1.amazonaws.com/lang/detect",
    method: "POST",
  },
  fileConvert: {
    id: "fileConvert",
    name: "File Format Convertion",
    description: "Converts the file with different formats",
    // url: "https://languageapi.krtrimaiq.ai:5008/file-convert",
    url: "https://languageapi.krtrimaiq.ai:5108/file-convert",
    method: "POST",
  },
  ocr: {
    id: "ocr",
    name: "Extract texts from the image",
    description: "Extract texts from the image",
    url: "https://languageapi.krtrimaiq.ai:5221/get-htr",
    method: "POST",
  },
  scanned_api:{
    id: "scanned_api",
    name:"Extract texts from the scanned image",
    description: "Extract texts from the image",
    url: "https://languageapi.krtrimaiq.ai:5103/file-translate",
    method: "POST",
  },  
  text_only:{
    id: "text_only",
    name:"Extract only texts",
    description: "Extract only texts",
    url: "https://languageapi.krtrimaiq.ai:5503/text-only",
    method: "POST",
  }, 
  textTranslate: {
    id: "textTranslate",
    name: "Translate from the Text to Text",
    description: "It is a Text to Text Translation",
    url: "https://languageapi.krtrimaiq.ai:5102/translate",
    method: "POST",
  },
  textEditor: {
    id: "textEditor",
    name: "Translate from the txt file",
    description: "It Translates from .txt documents",
    // url: "https://languageapi.krtrimaiq.ai:5213/file-translate",
    url: "https://languageapi.krtrimaiq.ai:6015/txt/translate",
    method: "POST",
  },
  pdfTranslate: {
    id: "pdfTranslate",
    name: "Translate from the pdf",
    description: "It Translates from .pdf documents",
    url: "https://languageapi.krtrimaiq.ai:5103/file-translate",
    method: "POST",
  },
  getJSONData: {
    id: "getJSONData",
    name: "Getting the document JSON from ID",
    description: "Getting the document JSON from ID",
    url: "https://languageapi.krtrimaiq.ai:5203/get-json",
    method: "POST",
  },
  saveJSONData: {
    id: "saveJSONData",
    name: "Saving the document JSON",
    description: "Saving the document JSON",
    // url: "https://languageapi.krtrimaiq.ai:5208/save-json",
    url: "https://mlmachine.krtrimaiq.ai:5267/editor/save",
    // url: "http://localhost:5267/editor/save",
    method: "POST",
  },
  corpusFeedback: {
    id: "corpusFeedback",
    name: "Sending the training Feedback data",
    description: "Sending the training Feedback data",
    url: "https://languageapi.krtrimaiq.ai:5207/corpus_feedback",
    method: "POST",
  },
  monoCorpus: {
    id: "monoCorpus",
    name: "Mono Corpus",
    description: "",
    // url: "https://languageapi.krtrimaiq.ai:5006/corpus-creation",
    url: "https://languageapi.krtrimaiq.ai:5109/corpus-creation",
    method: "POST",
  },
  paraCorpus: {
    id: "paraCorpus",
    name: "Para Corpus",
    description: "",
    // url: "https://languageapi.krtrimaiq.ai:5005/corpus-creation",
    url: "https://languageapi.krtrimaiq.ai:5104/corpus-creation",
    method: "POST",
  },
  userFeedback: {
    id: "userFeedback",
    name: "users feedback",
    description: "user feedback",
    url: "https://languageapi.krtrimaiq.ai:5267/user/feedback",
    method: "POST",
  },
  getFileFromUrl: {
    id: "getFileFromUrl",
    name: "Document Translation",
    description:
      "It translates the uploaded document to the translated document. i.e. doc2doc translator",
    mode: "blob",
    method: "GET",
  },
  login: {
    id: "login",
    name: "User Login API",
    description: "It's User Login API",
    // url: "https://l4yc68h0ub.execute-api.ap-south-1.amazonaws.com/dev/login-icmats",
    url: "https://languageapi.krtrimaiq.ai:5267/user/login",
    method: "POST",
  },
  adminSettings: {
    id: "adminSettings",
    name: "User Admin Settings",
    description: "It's User Admin Settings",
    // url: "https://l4yc68h0ub.execute-api.ap-south-1.amazonaws.com/dev/admin-settings",
    url: "https://languageapi.krtrimaiq.ai:5267/admin",
    method: "POST",
  },
  updateConfig: {
    id: "updateConfig",
    name: "Update User Global Config",
    description: "It will update the User's Global Configs",
    // url: "https://l4yc68h0ub.execute-api.ap-south-1.amazonaws.com/dev/update-global-config",
    url: "https://languageapi.krtrimaiq.ai:5212/update-configuration",
    method: "POST",
  },
  glossary: {
    id: "glossary",
    name: "User Glossary",
    description: "It performs CUD operation in user glossary",
    // url: "https://l4yc68h0ub.execute-api.ap-south-1.amazonaws.com/dev/glossary-v3",
    url: "https://languageapi.krtrimaiq.ai:5216/update-glossary",
    method: "POST",
  },
  userAPI: {
    id: "userAPI",
    name: "User API",
    description: "It's User API",
    // url: "https://l4yc68h0ub.execute-api.ap-south-1.amazonaws.com/dev/admin-settings",
    url: "https://languageapi.krtrimaiq.ai:5267/user",
    method: "POST",
  },
  bulkUpload: {
    id: "bulkUpload",
    name: "bulk upload to s3",
    description: "",
    url: "https://l4yc68h0ub.execute-api.ap-south-1.amazonaws.com/dev/pre-signed-bulk-v3",
    method: "POST",
  },
  getStats: {
    id: "getStats",
    name: "Get statistics of a given document by Id",
    description: "Get statistics of a given document by Id",
    // url: " https://languageapi.krtrimaiq.ai:5206/fetch-stats",
    url: " https://mlmachine.krtrimaiq.ai:5266/user/get_stats",
    method: "POST",
  },
  bulkStatus: {
    id: "bulkStatus",
    // url: "https://l4yc68h0ub.execute-api.ap-south-1.amazonaws.com/dev/bulk-status",
    url: "https://languageapi.krtrimaiq.ai:5112/fetch-details",
    method: "POST",
  },
  downloadFromActLog: {
    id: "downloadFromActLog",
    name: "Download from activity log",
    description: "",
    url: " https://l4yc68h0ub.execute-api.ap-south-1.amazonaws.com/dev/pre-signed-download",
    method: "POST",
  },
  updateCorpus: {
    id: "updateCorpus",
    name: "Corpus Update and Delete",
    description: "",
    url: "https://l4yc68h0ub.execute-api.ap-south-1.amazonaws.com/dev/update-corpus",
    method: "POST",
  },
  fetchDashboard:{
    id:"fetchDashboard",
    name:"Search Bar Data",
    description: "",
    url:"https://languageapi.krtrimaiq.ai:5267/user/dashboard_search",
    method:"POST",
  },
  txtTranslate:{
    id:"txtTranslate",
    name:"text Translate",
    description:"",
    url:"https://languageapi.krtrimaiq.ai:6016/txt/translate",
    method:"POST",
  },
  docTranslate:{
    id:"docTranslate",
    name:"doc Translate",
    description:"",
    mode:"form",
    url:"https://languageapi.krtrimaiq.ai:5013/docx-translate",
    method:"POST",
  },
  bulkSearch:{
    id:"bulkSearch",
    name: "bulk Search",
    description:"",
    url:"https://languageapi.krtrimaiq.ai:5114/bulk-search",
    method:"POST",
  }
};

export default servers;
